import { render, staticRenderFns } from "./PropReachTotal.vue?vue&type=template&id=7abf5244&"
import script from "./PropReachTotal.vue?vue&type=script&lang=js&"
export * from "./PropReachTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports